const authSignupRoutes = (prop) => [
  {
    path: 'services',
    name: prop + '.services',
    meta: { auth: false },
    component: () => import('../pages/Services.vue')
  },
  {
    path: 'service-details',
    name: prop + '.services',
    meta: { auth: false },
    component: () => import('../pages/ServiceDetails.vue')
  },
  {
    path: 'about-service-portal',
    name: prop + '.about_service_portal',
    meta: { auth: false },
    component: () => import('../pages/AboutPortal.vue')
  },
  {
    path: 'voluntary-social-welfare-institutions',
    // name: prop + '.home-2',
    // meta: { auth: true, name: 'Home 2' },
    // component: Dashboard2,
    redirect: { path: '/portal/service-details', query: { service_type: 'orgList', org_id: 4, service_id: 57 } }
  },
  {
    path: 'capitation-grant',
    // name: prop + '.home-2',
    // meta: { auth: true, name: 'Home 2' },
    // component: Dashboard2,
    redirect: { path: '/portal/service-details', query: { service_type: 'categoryList', service_category_id: 3, service_id: 2 } }
  },
  {
    path: 'hospital',
    redirect: { path: '/portal/service-details', query: { service_type: 'categoryList', service_category_id: 4, service_id: 3 } }
  },
  {
    path: 'moitri',
    redirect: { path: '/portal/service-details', query: { service_type: 'orgList', org_id: 6, service_id: 10 } }
  },
  {
    path: 'circular-bnswc',
    redirect: { path: '/portal/service-details', query: { service_type: 'orgList', org_id: 4, service_id: 57 } }
  },
  {
    path: 'ucd',
    redirect: { path: '/portal/service-details', query: { service_type: 'orgList', org_id: 4, service_id: 27 } }
  },
  {
    path: 'oporadhi',
    redirect: { path: '/portal/service-details', query: { service_type: 'orgList', org_id: 4, service_id: 5 } }
  },
  {
    path: 'rugikollan',
    redirect: { path: '/portal/service-details', query: { service_type: 'orgList', org_id: 4, service_id: 26 } }
  },
  {
    path: 'jatio-porjaye',
    redirect: { path: '/portal/service-details', query: { service_type: 'orgList', org_id: 4, service_id: 23 } }
  },
  {
    path: 'all-services',
    name: prop + '.services',
    meta: { auth: false },
    component: () => import('../pages/AllServices.vue')
  },
  {
    path: 'faq',
    name: prop + '.services',
    meta: { auth: false },
    component: () => import('../pages/FAQ.vue')
  },
  {
    path: 'notice',
    name: prop + '.services',
    meta: { auth: false },
    component: () => import('../pages/Notice.vue')
  },
  {
    path: 'news',
    name: prop + '.services',
    meta: { auth: false },
    component: () => import('../pages/News.vue')
  },
  {
    path: 'news-details/:id',
    name: prop + '.services',
    meta: { auth: false },
    component: () => import('../pages/NewsDetails.vue')
  },
  {
    path: 'policy',
    name: prop + '.services',
    meta: { auth: false },
    component: () => import('../pages/Policy.vue')
  },
  {
    path: 'terms',
    name: prop + '.services',
    meta: { auth: false },
    component: () => import('../pages/Terms.vue')
  },
  {
    path: '/portal/assistive-device-application',
    name: prop + '.services',
    meta: { auth: false },
    component: () => import('../pages/AssistiveDeviceApplicaton.vue')
  },
  {
    path: 'assistive-device',
    redirect: { path: '/portal/service-details', query: { service_type: 'orgList', org_id: 3, service_id: 35 } }
  },
  {
    path: 'hospital-services',
    redirect: { path: '/portal/service-details', query: { service_type: 'allService', service_id: 3 } }
  },
  {
    path: 'assistive-device-service',
    redirect: { path: '/portal/service-details', query: { service_type: 'orgList', org_id: 3, service_id: 35 } }
  },
  {
    path: 'therapeutic-service',
    redirect: { path: '/portal/service-details', query: { service_type: 'orgList', org_id: 3, service_id: 6 } }
  },
  {
    path: 'therapeutic',
    redirect: { path: '/portal/service-details', query: { service_type: 'orgList', org_id: 3, service_id: 6 } }
  },
  {
    // path: 'medical-treatment-service',
    path: 'medical-grant',
    redirect: { path: '/portal/service-details', query: { service_type: 'orgList', org_id: 2, service_id: 9 } }
  },
  {
    // path: 'medical-treatment-service',
    path: 'child-service',
    redirect: { path: '/portal/service-details', query: { service_type: 'customerTypeList', customer_type_id: 2, service_id: 25 } }
  },
  {
    path: 'government-children-family',
    redirect: { path: '/portal/service-details', query: { service_type: 'categoryList', service_category_id: 6, service_id: 29 } }
  },
  {
    path: 'citizen-card-form',
    name: prop + '.citizen_card_form',
    meta: { auth: false },
    component: () => import('../pages/citizen-card/CitizenForm.vue')
  },
  {
    path: 'promotion-dashboard',
    name: prop + '.promotion_dashboard',
    meta: { auth: false },
    component: () => import('../pages/promotion-dashboard/List.vue')
  }
]

const disabilitySchoolRoutes = (prop) => [
  {
    path: 'admission-form',
    name: prop + '.admission_form',
    meta: { auth: false },
    component: () => import('../pages/disability-school/AdmissionForm.vue')
  }
]

const trainingRoutes = (prop) => [
  {
    path: 'circular',
    name: prop + '.circular',
    meta: { auth: false },
    props: true,
    component: () => import('../pages/training-circular/List.vue')
  }
]

const grantAllowanceRoutes = (prop) => [
  {
    path: 'circular',
    name: prop + '.circular',
    meta: { auth: false },
    props: true,
    component: () => import('../pages/nddt-circular/List.vue')
  },
  {
    path: 'bnswc-circular',
    name: prop + '.bnswc_circular',
    meta: { auth: false },
    props: true,
    component: () => import('../pages/bnswc-circular/List.vue')
  }
]

const grantServiceRoutes = (prop) => [
  {
    path: 'bnswc-circular',
    name: prop + '.bnswc_circular',
    meta: { auth: false },
    props: true,
    component: () => import('../pages/bnswc-circular/List.vue')
  }
]

const routes = [
  {
    path: '/portal/home',
    component: () => import('@/layouts/auth-layouts/HomeLayout'),
    meta: { auth: false },
    children: [
      {
        path: '',
        name: 'portal.home',
        meta: { auth: false },
        component: () => import('../pages/Home.vue')
      }
    ]
  },
  {
    path: '/portal',
    name: 'portal',
    component: () => import('@/layouts/auth-layouts/PortalLayout'),
    meta: { auth: false },
    children: authSignupRoutes('portal')
  },
  {
    path: '/portal/disability-school',
    name: 'portal.disability_school',
    component: () => import('@/layouts/auth-layouts/PortalLayout'),
    meta: { auth: false },
    children: disabilitySchoolRoutes('portal.disability_school')
  },
  {
    path: '/portal/training-and-accommodation',
    name: 'portal.training_and_accommodation',
    component: () => import('@/layouts/auth-layouts/PortalLayout'),
    meta: { auth: false },
    children: trainingRoutes('portal.training_and_accommodation')
  },
  {
    path: '/portal/grant-allowance-pddt',
    name: 'portal.grant_allowance_pddt',
    component: () => import('@/layouts/auth-layouts/PortalLayout'),
    meta: { auth: false },
    children: grantAllowanceRoutes('portal.grant_allowance_pddt')
  },
  {
    path: '/portal/grant-service',
    name: 'portal.grant_service',
    component: () => import('@/layouts/auth-layouts/PortalLayout'),
    meta: { auth: false },
    children: grantServiceRoutes('portal.grant_service')
  }
]

export default routes
